import { Button } from '@mui/material';
import { useBreakpointDown } from '@/hooks/use-breakpoint';

interface ActionButtonProps {
  label: string;
  icon: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  dataTestId?: string;
}

export default function ActionButton({ label, icon, onClick, disabled, dataTestId }: ActionButtonProps) {
  const isSmallScreen = useBreakpointDown('sm');

  return (
    <Button
      variant="outlined"
      size="small"
      disabled={disabled}
      data-testid={dataTestId}
      component="span"
      role="button"
      tabIndex={0}
      color="info"
      sx={{
        fontSize: isSmallScreen ? '0.65rem' : '0.75rem',
      }}
      endIcon={icon}
      onClick={onClick}
    >
      {label}
    </Button>
  );
}
